import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import SWOTAnalysisApp from './SWOTAnalysisApp';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <SWOTAnalysisApp />
  </React.StrictMode>
);
